const doc = [({"en":({"js":({"admin":({"tenants":({"integrations":({"nav":({"bambora":"Bambora", "inventio":"Inventio", "shipmondo":"Shipmondo"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;